import { Route, Routes } from "react-router";
import { RequireStaff } from "./features/auth/RequireStaff";
import { SECTIONS } from "./features/nav/sections";
import { AppLayout } from "./layouts/AppLayout";
import { AuditPage } from "./routes/audit/page";
import { CardEditorPage } from "./routes/cards/editor";
import { CardsPage } from "./routes/cards/page";
import { PublishPage } from "./routes/cards/publish";
import { DashboardPage } from "./routes/dashboard/page";
import { LoginPage } from "./routes/login/page";
import { NotFoundPage } from "./routes/not-found/page";
import { RolesPage } from "./routes/roles/page";
import { SettingsPage } from "./routes/settings/page";
import { SitePage } from "./routes/site/page";
import { SoonPage } from "./routes/soon/page";
import { CannedPage } from "./routes/support/canned";
import { TicketDetailPage } from "./routes/support/detail";
import { SupportPage } from "./routes/support/page";
import { UserDetailPage } from "./routes/users/detail";
import { UsersPage } from "./routes/users/page";

export function App() {
  return (
    <Routes>
      <Route path="/entrar" element={<LoginPage />} />
      <Route element={<RequireStaff />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:id" element={<UserDetailPage />} />
          <Route path="/roles" element={<RolesPage />} />
          <Route path="/cards" element={<CardsPage />} />
          <Route path="/cards/publish" element={<PublishPage />} />
          <Route path="/cards/:id" element={<CardEditorPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/support/canned" element={<CannedPage />} />
          <Route path="/support/:number" element={<TicketDetailPage />} />
          <Route path="/site" element={<SitePage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          {SECTIONS.filter((s) => s.milestone).map((s) => (
            <Route key={s.key} path={s.path} element={<SoonPage section={s.key} milestone={s.milestone!} />} />
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
